module.exports = __webpack_public_path__ + "static/media/new_logo_img.63e686b8.jpg";